import SocialButton from 'components.v2/SocialButton'
import withContainer from './SocialButtonContainer'

export default withContainer(SocialButton)
